<template>
  <layout>
    <h4>
      News
      <router-link
        :to="{ name: 'news.create' }"
        class="btn btn-sm btn-primary">Create</router-link>
    </h4>
    <base-table
      :resource="resource">

      <template
        slot="title"
        slot-scope="{ item }">
        <a
          :href="item.link"
          target="_blank">
          {{ item.title }}
        </a>
      </template>

    </base-table>
  </layout>
</template>

<script>
import Layout from '../layouts/Default.vue';
import BaseTable from '../components/BaseTable.vue';
import Proxy from './Proxy';

const resourceBase = 'news';

export default {
  name: 'NewsIndex',

  components: {
    Layout,
    BaseTable,
  },

  data() {
    return {
      resource: {
        base: resourceBase,
        proxy() {
          return new Proxy();
        },
        sortBy: 'created_at',
        sortDesc: true,
        perPage: 9,
        fields: [
          {
            key: 'id',
            label: 'ID',
            sortable: true,
          },
          {
            key: 'locale',
            label: 'Locale',
            sortable: true,
          },
          {
            key: 'title',
            label: 'Title',
            sortable: true,
          },
          {
            key: 'created_at',
            label: 'Created',
            sortable: true,
          },
          // define column fields here
        ],
      },
    };
  },
};
</script>
